import { useContext, useState } from 'react';
import emailjs from 'emailjs-com';
import { DetailsContext } from '@/context/DetailContext';

export default function SubscribeNewsLetter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const { details } = useContext(DetailsContext);
  const handleSubscribe = async () => {
    if (!email) return;

    setStatus('sending');

    const templateParams = {
      name: 'Newsletter Subscriber',
      email: email,
      subject: 'New Newsletter Subscription',
      message: `A new user has subscribed to the newsletter.\n\nEmail: ${email}`,
      year: new Date().getFullYear(),
      to_email: details.email,
      heading: '📰 New Newsletter Subscription',
      is_contact: false,
      is_newsletter: true,
    };

    try {
      await emailjs.send(
        'service_q8hnaxs',
        'template_rcus0om',
        templateParams,
        'AmbQ-WAMkvA9EFT58'
      );
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000); // Reset after 3s
    } catch (error) {
      console.error('EmailJS Error:', error);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000); // Reset after 3s
    }
  };

  const getButtonLabel = () => {
    switch (status) {
      case 'sending':
        return 'SUBSCRIBING...';
      case 'success':
        return 'SUBSCRIBED ✅';
      case 'error':
        return 'TRY AGAIN ❌';
      default:
        return 'SUBSCRIBE';
    }
  };

  return (
    <div className="mt-[3rem] flex w-full justify-center md:mt-[6rem]">
      <div
        style={{ backgroundImage: `url('/herobg.jpg')` }}
        className="relative flex w-full max-w-[116rem] flex-wrap items-center justify-center gap-[4rem] rounded-[1rem] bg-cover bg-no-repeat px-[2rem] py-[10rem] font-inter"
      >
        <div className="absolute left-0 top-0 z-[0] h-full w-full bg-[#00142C] opacity-[0.95]"></div>
        <div className="z-[111] flex w-full flex-wrap items-center justify-center gap-[2rem]">
          <h1 className="w-full text-center text-[3.6rem] font-[600] leading-[4.6rem] text-white">
            Subscribe Our Newsletter
          </h1>
          <p className="w-full max-w-[80rem] text-center text-[1.6rem] leading-[2.6rem] text-[#FFFFFF]">
            Stay updated with the latest security solutions, tips, and company updates directly in
            your inbox.
          </p>

          <div className="z-[5555] flex h-[6.56rem] w-full max-w-[50rem] flex-row flex-wrap justify-center gap-[4rem] rounded-[1rem] bg-white px-[1rem]">
            <div className="flex w-full items-center justify-between">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="text-footer-bottom-header-content h-none w-full appearance-none rounded-md px-[1rem] py-[1.5rem] text-[1.6rem] text-[#011936] outline-none"
              />

              <div
                onClick={status !== 'sending' ? handleSubscribe : null}
                className={`flex h-[5.4rem] w-[22.10rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] rounded-[0.6rem] ${
                  status === 'success'
                    ? 'bg-green-600'
                    : status === 'error'
                      ? 'bg-red-600'
                      : 'bg-[#0EC9AC]'
                } text-[1.6rem] font-[400] text-[#F9FEFF] transition-all duration-300`}
              >
                <p className="text-[1.6rem] font-[600]">{getButtonLabel()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
